import type { ComponentProps, FC } from 'react';
import { SvgIcon } from './SvgIcon';

type Props = ComponentProps<typeof SvgIcon>;

const Icon: FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.76657 10.2766C6.81256 10.3408 6.87319 10.3931 6.94344 10.4291C7.01368 10.4652 7.09151 10.4841 7.17048 10.4841C7.24945 10.4841 7.32728 10.4652 7.39752 10.4291C7.46776 10.3931 7.52839 10.3408 7.57438 10.2766L10.865 5.71406C10.9244 5.63125 10.865 5.51563 10.7634 5.51563H10.0306C9.87126 5.51563 9.7197 5.59219 9.62595 5.72344L7.17126 9.12969L6.05876 7.58594C5.96501 7.45625 5.81501 7.37813 5.65407 7.37813H4.92126C4.8197 7.37813 4.76032 7.49375 4.8197 7.57656L6.76657 10.2766Z"
        fill="black"
      />
      <path
        d="M13.75 1.75H2.25C1.97344 1.75 1.75 1.97344 1.75 2.25V13.75C1.75 14.0266 1.97344 14.25 2.25 14.25H13.75C14.0266 14.25 14.25 14.0266 14.25 13.75V2.25C14.25 1.97344 14.0266 1.75 13.75 1.75ZM13.125 13.125H2.875V2.875H13.125V13.125Z"
        fill="black"
      />
    </svg>
  );
};

export const CommentReadIcon: FC<Props> = (props) => {
  return <SvgIcon size={16} component={Icon} {...props} />;
};
